<template>
  <div class="pa-2">
    <h4 class="settings-h4">Administration Settings</h4>
    
    <div class="wrapper-2 pa-4 mb-4 pos-relative">
      <div class="d-flex align-center mw-400 justify-space-between mb-2">

        <span class="fs-1-12r">Email addresses to send mail about broken shortcuts: </span>
        <div class="d-flex justify-end mw-400 mt-2">
          <v-icon
          @click="
            organization.administrationDefinitions.emailsToNotifyAboutBrokenShortcuts.push(
              ''
            )
            "
          >mdi-plus-circle-outline</v-icon
          >
        </div>
      </div>
      <div
        v-for="(email, i) of organization.administrationDefinitions
          .emailsToNotifyAboutBrokenShortcuts"
        class="d-flex justify-space-between"
      >
        <v-text-field
          v-model="
            organization.administrationDefinitions
              .emailsToNotifyAboutBrokenShortcuts[i]
          "
          hide-details
          dense
          class="my-1 mw-400"
          :append-icon="
            organization.administrationDefinitions
              .emailsToNotifyAboutBrokenShortcuts.length > 1
              ? 'mdi-minus-circle-outline'
              : ''
          "
          @click:append="removeItemFromArr(email)"
        />
      </div>

    </div>
  </div>
</template>

<script>
import OnlineHelp from '@/components/BaseComponents/OnlineHelp/OnlineHelp.vue'
import { mapGetters } from 'vuex'

//Childrens
import InputsSenderVendor from '@/components/SingleOrganization/OrganizationSettingsChildern/EmailSettings/Childrens/InputsSenderVendor/InputsSenderVendor.vue'

export default {
  name: 'AdministrationSettings',
  // data() {},
  props: {
    organization: Object,
  },

  components: { InputsSenderVendor, OnlineHelp },

  computed: {
    ...mapGetters(['loggedUser']),
  },
  methods: {
    removeItemFromArr(item) {
      if (
        this.organization.administrationDefinitions.emailsToNotifyAboutBrokenShortcuts.every(
          el => !el
        )
      ) {
        this.organization.administrationDefinitions.emailsToNotifyAboutBrokenShortcuts =
          ['']
      } else {
        this.organization.administrationDefinitions.emailsToNotifyAboutBrokenShortcuts =
          this.organization.administrationDefinitions.emailsToNotifyAboutBrokenShortcuts.filter(
            el => el !== item
          )
      }
    },
  },
  onMounted() {
    console.log('mounted')
    console.log(this.organization)
    if (
      this.organization.administrationDefinitions
        .emailsToNotifyAboutBrokenShortcuts.length === 0
    ) {
      this.organization.administrationDefinitions.emailsToNotifyAboutBrokenShortcuts.push(
        ''
      )
    }
  },
}
</script>
